<template>
  <section id="voucher_list_box">
    <ul id="voucher_list_abled">
      <!-- 有效 -->
      <voucher-li v-for="(item,index) in voucher_list" v-if="!!item.status" :voucher="item" :key="index"></voucher-li>
      <!-- 无效 -->
      <voucher-li v-for="(item,index) in voucher_list" v-if="!item.status" :voucher="item" :key="index" class="disabled"></voucher-li>
    </ul>
  </section>
</template>
<script>
  // js库
  import urls from '../../common/js/urls.js'
  import VoucherLi from "./VoucherLi"
  export default {
    name: 'personal-voucher',
    components: {
      VoucherLi
    },
    data() {
      return {
        voucher_list: [],
      }
    },
    computed: {
      user_id() {
        return this.$store.state.user.user_id;
      },
    },
    created: function() { //-------------------- 获取优惠券
      var _this = this;    
      this.axios.get(urls.get_voucher_list+"?user_id="+ _this.user_id).then(function(response) {
        _this.voucher_list = response.data.result.voucherList;
        if($.isEmptyObject(_this.voucher_list)){
            $("#voucher_list_abled").append('暂无可用优惠券');
        }
        //_this.$parent.setVoucherLength(_this.voucher_list.length);
      })
    }
  }

</script>
<style scoped>
  #voucher_list_box {
    width: 500px;
    list-style: none;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/Personal/PersonalVoucher.vue